<template>
  <div>
    <svg viewBox="-200 30 580 200" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <symbol id="RadSite" viewBox="-32.7 -37.8 65.4 75.6">
        <polygon class="st0" points="-24.6,4.7 -16.4,9.5 -32.7,18.9 -32.7,0" :style="{ fill: 'rgb(0, 151, 182)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st1" points="-24.6,-4.7 -32.7,0 -32.7,-18.9 -24.6,-14.2" :style="{ fill: 'rgb(170, 213, 154)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st2" points="-24.6,4.7 -32.7,0 -24.6,-4.7" :style="{ fill: 'rgb(14, 128, 160)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st3" points="-32.7,-18.9 -24.6,-23.6 -24.6,-14.2" :style="{ fill: 'rgb(60, 176, 156)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st2" points="0,-37.8 16.4,-28.4 0,-18.9" :style="{ fill: 'rgb(14, 128, 160)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st3" points="16.4,-9.5 16.4,-28.4 32.7,-18.9" :style="{ fill: 'rgb(60, 176, 156)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st4" points="0,-18.9 16.4,-28.4 16.4,-9.5" :style="{ fill: 'rgb(36, 152, 160)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st5" points="24.6,-4.7 16.4,-9.5 32.7,-18.9 32.7,0" :style="{ fill: 'rgb(8, 150, 179)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st6" points="24.6,14.2 24.6,4.7 32.7,0 32.7,18.9" :style="{ fill: 'rgb(173, 213, 145)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st2" points="24.6,-4.7 32.7,0 24.6,4.7" :style="{ fill: 'rgb(14, 128, 160)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st7" points="32.7,18.9 24.6,23.6 24.6,14.2" :style="{ fill: 'rgb(69, 175, 155)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st8" points="0,37.8 -16.4,28.4 0,18.9" :style="{ fill: 'rgb(0, 125, 165)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st9" points="-16.4,9.5 -16.4,28.4 -32.7,18.9" :style="{ fill: 'rgb(54, 149, 125)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st10" points="0,18.9 -16.4,28.4 -16.4,9.5" :style="{ fill: 'rgb(77, 175, 155)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st11" points="-24.6,-14.2 -16.4,-9.5 -24.6,-4.7" :style="{ fill: 'rgb(210, 231, 196)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st12" points="-24.6,4.7 -24.6,-4.7 -16.4,-9.5 -16.4,9.5" :style="{ fill: 'rgb(26, 169, 225)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st13" points="-16.4,-9.5 -24.6,-14.2 -24.6,-23.6 -16.4,-28.4" :style="{ fill: 'rgb(155, 215, 246)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st14" points="-16.4,-28.4 0,-37.8 0,-18.9" :style="{ fill: 'rgb(25, 179, 232)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st15" points="-16.4,-28.4 0,-18.9 -16.4,-9.5" :style="{ fill: 'rgb(103, 200, 201)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st11" points="24.6,4.7 24.6,14.2 16.4,9.5" :style="{ fill: 'rgb(210, 231, 196)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st12" points="16.4,-9.5 24.6,-4.7 24.6,4.7 16.4,9.5" :style="{ fill: 'rgb(26, 169, 225)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st16" points="16.4,9.5 24.6,14.2 24.6,23.6 16.4,28.4" :style="{ fill: 'rgb(158, 218, 247)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st14" points="16.4,28.4 0,37.8 0,18.9" :style="{ fill: 'rgb(25, 179, 232)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
        <polygon class="st17" points="16.4,28.4 0,18.9 16.4,9.5" :style="{ fill: 'rgb(92, 201, 244)' }">
          <animate attributeName="fill" repeatCount="indefinite" :values="colorValues()" :dur="colorDuration()" />
        </polygon>
      </symbol>
      <use width="50" height="50" transform="matrix(1.6983, 0, 0, -1.6983, 46.831902, 167.595016)" style="overflow:visible;" xlink:href="#RadSite"></use>
    </svg>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      colors: [
        'rgb(0, 151, 182)', 'rgb(170, 213, 154)', 'rgb(14, 128, 160)', 'rgb(60, 176, 156)', 'rgb(14, 128, 160)', 'rgb(60, 176, 156)',
        'rgb(36, 152, 160)', 'rgb(8, 150, 179)', 'rgb(173, 213, 145)', 'rgb(14, 128, 160)', 'rgb(69, 175, 155)', 'rgb(0, 125, 165)',
        'rgb(54, 149, 125)', 'rgb(77, 175, 155)', 'rgb(210, 231, 196)', 'rgb(26, 169, 225)', 'rgb(155, 215, 246)', 'rgb(25, 179, 232)',
        'rgb(103, 200, 201)', 'rgb(210, 231, 196)', 'rgb(26, 169, 225)', 'rgb(158, 218, 247)', 'rgb(25, 179, 232)', 'rgb(92, 201, 244)'
      ]
    }
  },
  methods: {
    colorValues() {
      return _.shuffle(this.colors).join(';');
    },
    colorDuration() {
      return Math.floor((Math.random() * 10) + 5) + 's';
    }
  }
}
</script>
